import styled from 'styled-components';
import { breakpointsDesktopFirst } from '../../../themes/breakpoints';

export const FlexCol = styled.div`
display: flex;
flex-direction: column;
background-color: #f5f5f5;
padding: 1rem 2rem;
border-radius: 0 0 10px 0;

@media ${breakpointsDesktopFirst.tablet} {
  border-radius: 0 0 0 0;
}
`;

export const SummaryModalHeader1 = styled.div`
  margin-bottom: 10px;
  font-size: 1.3rem;
  font-weight: bold;
`;

export const SummaryModalHeader2 = styled.div`
  margin-top: 15px;
  margin-bottom: 5px;
  font-size: 1.0rem;
  font-weight: bold;
`;

export const SummaryModalTotals = styled.div`
  margin-top: 15px;
  border-top: 1px solid #999999;
  padding-top: 10px;
  font-size: 1.3rem;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  span:first-child {
    text-align: left;
  };
  span:last-child {
    text-align:right;
  };
`;

export const SummaryModalProductList = styled.div`
  overflow-y: auto;
  min-height: 50px;
  max-height: 270px;
`;

export const SummaryModalProduct = styled.div`
  margin: 15px 0px;
  font-size: .875rem;
  display: flex;
  justify-content: space-between;
  span:first-child {
    text-align: left;
  };
  span:nth-child(2) {
    text-align:left;
    margin: 0 5px;
    width: 10px;
  }
  span:last-child {
    text-align:right;
  }
`;
